/*
 * @Author: Junchi Zhao
 * @LastEditors: Junchi Zhao
 * @Description:  组件弹窗调用地址
 */
export default {
  components: {}
};
